module.exports = __webpack_public_path__ + "media/images/schuzka-25befebd4d8b44b7a6d2bfa0709bab71.png";